/**
 * Overrides LOCAIS (por usuário/navegador) de visibilidade e cor das camadas de
 * mapa. NÃO vão para o banco: o backend guarda o `default` compartilhado (o que
 * todos veem); aqui fica o ajuste pessoal, que sobrevive ao reload via
 * localStorage e some ao "restaurar padrão".
 *
 * Formato armazenado, por Local: { [camadaId]: { cor?, visivel? } } — só os
 * campos ajustados entram; o resto cai no default.
 */

const chave = (localId) => `flow.mapa-camadas.overrides.${localId}`

export function carregarOverrides(localId) {
  try {
    const bruto = localStorage.getItem(chave(localId))
    return bruto ? JSON.parse(bruto) : {}
  } catch {
    // JSON corrompido / localStorage indisponível: começa sem overrides.
    return {}
  }
}

function gravar(localId, overrides) {
  try {
    localStorage.setItem(chave(localId), JSON.stringify(overrides))
  } catch {
    // localStorage cheio/indisponível: o override só não sobrevive ao reload.
  }
}

// Substitui o override INTEIRO da camada por `override` (só os campos que
// divergem do default). Se vier vazio/nulo, remove — assim o estado que voltou
// a bater com o default não deixa override órfão nem flag acesa.
export function substituirOverride(localId, camadaId, override) {
  const overrides = carregarOverrides(localId)
  if (!override || Object.keys(override).length === 0) {
    delete overrides[camadaId]
  } else {
    overrides[camadaId] = override
  }
  gravar(localId, overrides)
  return overrides
}

// Descarta o override da camada (volta ao default do banco).
export function removerOverride(localId, camadaId) {
  const overrides = carregarOverrides(localId)
  delete overrides[camadaId]
  gravar(localId, overrides)
  return overrides
}

// Remove overrides de camadas que não existem mais (deletadas/substituídas no
// banco), para o localStorage não acumular lixo.
export function podarOverrides(localId, camadaIdsValidos) {
  const overrides = carregarOverrides(localId)
  const validos = new Set(camadaIdsValidos.map(String))
  let mudou = false
  Object.keys(overrides).forEach((id) => {
    if (!validos.has(String(id))) {
      delete overrides[id]
      mudou = true
    }
  })
  if (mudou) gravar(localId, overrides)
  return overrides
}
